module.exports = __webpack_public_path__ + "img/full4-min.5c0260ec.png";